import { render } from "./SiIntroduction_2.vue?vue&type=template&id=e61a2ac0&scoped=true"
import script from "./SiIntroduction_2.vue?vue&type=script&lang=js"
export * from "./SiIntroduction_2.vue?vue&type=script&lang=js"

import "./SiIntroduction_2.vue?vue&type=style&index=0&id=e61a2ac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e61a2ac0"]])

export default __exports__